import { render, staticRenderFns } from "./OauthLoginWrapper.vue?vue&type=template&id=e09b1bc0"
import script from "./OauthLoginWrapper.vue?vue&type=script&lang=js"
export * from "./OauthLoginWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports